angular.module('capability-ng-scheduler').directive('eabCampusList', function eabCampusList() {
  'use strict';

  return {
    replace: true,
    templateUrl:
      'capability-ng-scheduler/src/views/course_scheduler/modals/suggestions/components/campus_list/campus_list.html',
    scope: {
      eabCampusList: '='
    }
  };
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/course_scheduler/modals/suggestions/components/campus_list/campus_list.js